export default __webpack_public_path__ + "static/media/adminAdd.ec3208b1.svg";